export const blogData = [
    {
        id: 1,
        title: '7 JavaScript Tricks You Should Know',
        description: 'These tips became treasures when I found out about them, this tricks will make you life more easier.',
        date: 'Nov 7, 2021',
        image: 'https://miro.medium.com/max/800/1*M_GDn6RXZSZC66kvrMHh5Q.png',
        url: ''
    },
    {
        id: 2,
        title: 'MERN Stack Developer Hacks',
        description: "I've developed many full stack web applications with the MERN stack. I thought I would share some helpful tips & tricks I've found that will help those who are current learning or already know the MERN stack.",
        date: 'Dec 11, 2022',
        image: 'https://res.cloudinary.com/practicaldev/image/fetch/s--XhVRGdz8--/c_imagga_scale,f_auto,fl_progressive,h_720,q_auto,w_1280/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/epv55hgtsfi8csprpj9u.jpg',
        url: ''
    },
    {
        id: 3,
        title: '7 Git Hacks You Just Can’t Ignore',
        description: 'Git has probably saved more developers jobs than any other technology. As long as you frequently save your work with Git, you will always be able to roll back to how your code was in the past.',
        date: 'Nov 14, 2022',
        image: 'https://cdn-media-1.freecodecamp.org/images/1*_RzIXapqnP4ZZ9twx5_KSg.jpeg',
        url: ''
    },
    {
        id: 4,
        title: 'CHECK INTERNET SPEED FROM THE COMMAND LINE',
        description: 'Want to check your internet speed from the terminal? Here\'s the perfect way to the that.',
        date: 'Nov 17, 2022',
        image: 'https://1.bp.blogspot.com/-XTVMsZP3HaM/Xxpl394txlI/AAAAAAAABws/zovXWiuNGg4TzBwYYVFfJ1ixDb3JfVokgCNcBGAsYHQ/w400-h195/speedtest.png',
        url: ''
    },
    {
        id: 5,
        title: 'GET MICHAEL\'S OR TREVOR\'S VEHICLES FULLY UPGRADED IN GTA V FOR FREE',
        description: 'In case you haven\'t heard of this game, GTA stands for \'Grand Theft Auto\'. It is an open-world game published by Rockstar Games.',
        date: 'Dec 1, 2022',
        image: 'https://1.bp.blogspot.com/-jhdtUBIRD_s/XxLFKQuRz9I/AAAAAAAABsM/mClfbfDFKvsUwA7Wyi25Lzu3DEmL2lxrACNcBGAsYHQ/s1919/gta.jpg',
        url: ''
    },
]




// Do not remove any fields.
// Leave it blank instead as shown below.


/* 
{
    id: 1,
    title: 'Car Pooling System',
    description: '',
    date: 'Oct 1, 2020',
    image: '',
    url: 'https://preview.colorlib.com/theme/rezume/'
}, 
*/